import { Suspense, useEffect, useRef } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import { captureAttribution } from "@/lib/attribution";
import { initAnalytics, trackPageView, bindClickTracking } from "@/lib/analytics";

import Opportunity from "@/pages/Opportunity";
import InvestmentSupport from "@/pages/InvestmentSupport";
import Process from "@/pages/Process";
import Contact from "@/pages/Contact";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfUse from "@/pages/TermsOfUse";
import ThankYou from "@/pages/ThankYou";
import NotFound from "@/pages/NotFound";

function RouteEffects() {
  const { pathname } = useLocation();
  const first = useRef(true);
  useEffect(() => {
    if (first.current) { first.current = false; trackPageView(pathname); return; }
    window.scrollTo(0, 0);
    document.getElementById("main")?.focus({ preventScroll: true });
    const t = setTimeout(() => trackPageView(pathname), 50);
    return () => clearTimeout(t);
  }, [pathname]);
  return null;
}

export default function App() {
  useEffect(() => {
    captureAttribution();
    initAnalytics();
    return bindClickTracking();
  }, []);

  return (
    <>
      <RouteEffects />
      <a href="#main" className="sr-only z-[60] bg-gold px-4 py-3 font-semibold text-ink focus:not-sr-only focus:fixed focus:left-4 focus:top-4" data-testid="skip-link">Skip to main content</a>
      <Header />
      <main id="main" tabIndex={-1}>
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/opportunity" element={<Opportunity />} />
            <Route path="/investment-support" element={<InvestmentSupport />} />
            <Route path="/process" element={<Process />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-use" element={<TermsOfUse />} />
            <Route path="/thank-you" element={<ThankYou />} />
            <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Suspense fallback={null}><Footer /></Suspense>
    </>
  );
}
